import { getBoatName } from '@utils/getBoatName';
import { Image as AntImage } from 'antd';
import { FC, useMemo } from 'react';
import { getComparableBoatGallery } from '../hooks/comparableBoatGallery';
import {
  StoredBoat,
  useBoatIndexToShowGallery,
  useComparableBoats,
  useComparableBoatsById,
  useSetBoatIndexToShowGallery,
} from '../hooks/useCompare';
import { BoatGalleryModalProps } from './BoatGalleryModal.props';

const BoatGalleryModal: FC<BoatGalleryModalProps> = () => {
  const boatIndexToShowGallery = useBoatIndexToShowGallery();
  const setBoatIndexToShowGallery = useSetBoatIndexToShowGallery();
  const comparableBoats = useComparableBoats();
  const comparableBoatsById = useComparableBoatsById();

  const showModalGallery = useMemo<boolean>(() => {
    if (!!boatIndexToShowGallery || boatIndexToShowGallery === 0) {
      if (comparableBoats.length && comparableBoats[boatIndexToShowGallery]) {
        return true;
      }
    }

    return false;
  }, [boatIndexToShowGallery, comparableBoats]);

  const boat = useMemo<StoredBoat | undefined>(() => {
    if (showModalGallery) {
      if (comparableBoats[boatIndexToShowGallery]) {
        return comparableBoats[boatIndexToShowGallery];
      }
    }

    return undefined;
  }, [boatIndexToShowGallery, comparableBoats, showModalGallery]);

  const boatTitle = useMemo(() => getBoatName(boat?.attributes), [boat]);

  /**
   * The pictures come from the boat's Sanity document — the store keeps only the cover image, as
   * the thumbnail for the picker card.
   */
  const galleryImages = useMemo(
    () => getComparableBoatGallery(boat && comparableBoatsById.get(boat._id), boat, boatTitle),
    [boat, comparableBoatsById, boatTitle],
  );

  if (showModalGallery && boat) {
    return (
      <div style={{ display: 'none' }}>
        <AntImage.PreviewGroup
          preview={{
            visible: showModalGallery,

            onVisibleChange: (visible) => {
              if (!visible) {
                setBoatIndexToShowGallery(undefined);
              }
            },
          }}
        >
          {galleryImages.map((item) => (
            <AntImage src={item.src} key={item.key} loading="lazy" alt={item.alt} />
          ))}
        </AntImage.PreviewGroup>
      </div>
    );
  }

  return null;
};

export { BoatGalleryModal };
